import $ from 'jquery';

window.addEventListener('load', function() {

  var $commercant_list = $('.js-list-commercants');
  
  if(!$commercant_list.length)
    return;

  var commercant_type;
  var search;

  // Load Commercants on Page Init 
  loadCommercants();
  
  // On filters change, create a new List
  $( "select#select_type" ).change(function() { // On Dropdown Type change
    loadCommercants();
  });
  $( ".commercant_search__submit" ).click(function() { // On Input Button submit
    loadCommercants();
  });
  $('input').keypress(function(event) { // On Input enter
    if (event.keyCode == 13)
      loadCommercants();
  });

  // Show previous Page, Load hidden next Page with filters
  function loadCommercants(){

    // Empty List and get potentially updated filters data
    $commercant_list.empty();
    commercant_type = $('select#select_type').val();
    search = $('input#commercant_search').val();
    
    // Ajax Post
    $.ajax({
      cache: true,
      url: ajaxurl,
      type: 'get',
      data: {
        action: 'load_commercants',
        commercant_type: commercant_type,
        search: search,
      },
      success: function( html ) {
        $commercant_list.append( html );
        new Foundation.Accordion($commercant_list);
      }
    });

  }

});




